import React, { useState } from 'react';
import { Divider, HStack, IconValidationValid, Stack, Text } from '@adc/parallax-component-library';
import { PracticeErrorCode } from 'Enums';
import { useApiError, useLibrePractice, useToast } from 'Hooks';
import { Button, Footer, Main, RichText, ScrollContainer, Spinner, TitleActionBar, } from 'Components/utility';
import { SHOW_MODAL } from 'Reducers/modal/types';
import { applyPhoneNumberMask, getDocumentPathFromLanguage } from 'Utilities/dataHelpers';
import i18n from 'Utilities/i18n';
import mediator from 'Utilities/mediator';
import { store } from 'Utilities/store';
const InfoComponent = ({ label, text, withDivision, testID, }) => {
    return (React.createElement(Stack, null,
        React.createElement(Text, { testID: `${testID}-label`, color: "$text.60", fontWeight: "$bodySmall.default", fontSize: "$bodySmall.default" }, label),
        React.createElement(Text, { testID: testID, color: "$text.100", fontWeight: "$bodyBase.medium", fontSize: "$bodyBase.medium" }, text),
        withDivision && React.createElement(Divider, { marginVertical: "$4", borderColor: "$neutral.40" })));
};
const AddPracticeSecondStep = ({ values: practiceConnection, back }) => {
    const [loading, setLoading] = useState(false);
    const { showApiErrorModal } = useApiError();
    const { showToast } = useToast();
    const { addPractice } = useLibrePractice();
    if (!practiceConnection) {
        mediator.publish('router:navigate', '/connections');
        return null;
    }
    const displayMessageError = (modalProps) => {
        store.dispatch({
            type: SHOW_MODAL,
            modalProps: modalProps,
        });
    };
    const handleClickBtnBack = () => {
        back();
    };
    const onPrivacyNoticeLinkClick = () => {
        const { documentsUrl, documents } = store.getState().config;
        const { language } = store.getState().lang;
        const privacyNoticePath = getDocumentPathFromLanguage(documents?.privacypolicy, language);
        if (privacyNoticePath) {
            const privacyNoticeFullUrl = `${documentsUrl}${privacyNoticePath}`;
            window.open(privacyNoticeFullUrl, '_blank');
        }
    };
    const handleConnectButton = async () => {
        try {
            setLoading(true);
            const { errorCode, practiceBody } = await addPractice(practiceConnection.practiceId);
            if (practiceBody) {
                showToast({
                    message: i18n.t('Connections.modals.practiceAddedToast.body'),
                    'aria-label': i18n.t('Connections.modals.practiceAddedToast.body'),
                    icon: React.createElement(IconValidationValid, { color: "$support.positive.default" }),
                });
                return mediator.publish('router:navigate', {
                    url: '/lv-practice-connection',
                    data: { practiceConnection: practiceBody },
                });
            }
            switch (errorCode) {
                case PracticeErrorCode.TOO_MANY_CONNECTIONS:
                    displayMessageError({
                        details: i18n.t('Connections.modals.maxPracticesError.body'),
                        testID: 'TooManyConnections',
                    });
                    break;
                default:
                    showApiErrorModal();
            }
        }
        catch {
            showApiErrorModal();
        }
        finally {
            setLoading(false);
        }
    };
    return (React.createElement(Main, null,
        React.createElement(TitleActionBar, { testID: "AddPracticeID.primaryText", title: i18n.t('Connections.content.confirmPractice.primaryText'), closeBtn: true }),
        loading && React.createElement(Spinner, { "aria-label": "loading", testID: "AddPracticeID.spinner" }),
        React.createElement(ScrollContainer, { marginTop: 19 },
            React.createElement(Text, { testID: "AddPracticeID.secondaryText", fontSize: "$bodyBase.default", fontWeight: "$bodyBase.default", lineHeight: "$bodyBase.default", color: "$text.100", marginHorizontal: "$4" }, i18n.t('Connections.content.confirmPractice.secondaryText')),
            React.createElement(Stack, { margin: "$4", padding: "$4", marginTop: "$2", backgroundColor: "$surface.container", border: "$1.5", shadow: "$1" },
                React.createElement(Text, { testID: "AddPracticeID.title", color: "$text.100", fontWeight: "$h4.medium", fontSize: "$h4.medium", marginBottom: "$7" }, practiceConnection.name),
                React.createElement(InfoComponent, { label: i18n.t('Connections.content.confirmPractice.formField.practiceID.label'), text: practiceConnection.businessId, withDivision: true, testID: "AddPracticeID.formField.practiceID" }),
                React.createElement(InfoComponent, { label: i18n.t('Connections.content.confirmPractice.formField.practiceAddress.label'), text: `${practiceConnection.address1}, ${practiceConnection.city}, ${practiceConnection.state} ${practiceConnection.zip}`, withDivision: true, testID: "AddPracticeID.formField.practiceAddress" }),
                React.createElement(InfoComponent, { label: i18n.t('Connections.content.confirmPractice.formField.practicePhoneNumber.label'), testID: "AddPracticeID.formField.practicePhoneNumber", text: applyPhoneNumberMask(practiceConnection.phoneNumber) }))),
        React.createElement(Footer, { buttonText: "", customProps: React.createElement(Stack, { marginHorizontal: "$3" },
                React.createElement(RichText, { text: i18n.t('Connections.content.pendingInvitation.bodyText'), color: "$text.60", testID: "AddPracticeID.secondary.bodyText", onPressLink: onPrivacyNoticeLinkClick, fontToken: "$labelBase.default" }),
                React.createElement(HStack, { justifyContent: "space-between", marginTop: "$4" },
                    React.createElement(Button, { marginRight: "$2", onPress: handleClickBtnBack, testID: "AddPracticeID.common.back", "aria-label": i18n.t('Global.microcopy.common.back'), label: i18n.t('Global.microcopy.common.back'), flexGrow: 1, variant: "secondary" }),
                    React.createElement(Button, { marginLeft: "$2", onPress: handleConnectButton, testID: "AddPracticeID.common.connect", "aria-label": i18n.t('Global.microcopy.common.connect'), label: i18n.t('Global.microcopy.common.connect'), flexGrow: 1 }))) })));
};
export default AddPracticeSecondStep;
